import React from 'react'
import PropTypes from 'prop-types'

import {
  StyledWrapper,
} from './ItemListText.styled';

const ItemListText = props => {
  const { children } = props;
  return (
    <StyledWrapper>
      {children}
    </StyledWrapper>      
  )
}

ItemListText.propTypes = {
  children: PropTypes.node,
}

export default ItemListText
